import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../../helper/supabaseClient";
import { loginRedirectLogic } from "../../pages/AuthPages/Login";
import { setCredentials } from "../../features/authSlice";
import { getSites } from "../../pages/StorePages/UserStores";
import { useDispatch } from "react-redux";

const AuthCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
      
      const { data: sessionData,error: sessionError,} = await supabase.auth.getSession();

        if (sessionError) {
          console.error("Error parsing session from URL:", sessionError);
          navigate("/login?error=google-login-failed");
          return;
        }

        // sessionData.session should now be available
        const session = sessionData?.session;
        if (!session || !session.user) {
          console.error("No session");
          navigate("/login?error=google-login-failed");
          return;
        }

        // Fetch user sites same as email login path
        const userSites = await getSites(session.user.id);

        const mappedUser = {
          id: session.user.id,
          email: session.user.email ?? "",
          first_name: (session.user.user_metadata as any)?.first_name ?? "",
          last_name: (session.user.user_metadata as any)?.last_name ?? "",
          last_login: new Date().toISOString(),
          sites: userSites?.data || [],
        };

        // Persist in Redux exactly like the email login flow
        dispatch(
          setCredentials({
            user: mappedUser,
            token: session.access_token,
            refresh_token: session.refresh_token,
          })
        );

        // Reuse your login redirect logic so preview/slug rules stay consistent
        loginRedirectLogic(navigate, {
          user: mappedUser,
          access: session.access_token,
          refresh: session.refresh_token,
        } as any);

        // Clean URL to remove auth fragments
        try {
          window.history.replaceState({}, document.title, window.location.pathname);
        } catch (e) {
        }
      } catch (err) {
        console.error("Unexpected error in auth callback:", err);
        navigate("/login?error=google-login-failed");
      }
    };

    handleAuthCallback();
  }, [dispatch, navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
                <p className="text-lg text-gray-700 mb-2">Completing login...</p>
                <p className="text-sm text-gray-500">Please wait a moment</p>
            </div>
        </div>
    );
};

export default AuthCallback;
